var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorSymbol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 143,
    height: 58.102,
    viewBox: "0 0 143 58.102",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9477",
    "data-name": "Group 9477",
    transform: "translate(-711.5 -325.898)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_661",
    "data-name": "Line 661",
    x2: 74,
    transform: "translate(778 338)",
    fill: "none",
    stroke: "#ededed",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9476",
    "data-name": "Group 9476",
    transform: "translate(11.244 -2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9474",
    "data-name": "Group 9474",
    transform: "translate(-18838.063 -6286.92)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5650",
    "data-name": "Path 5650",
    d: "M24.847,6.928a5.141,5.141,0,0,1,9.991,0,5.142,5.142,0,0,0,7.674,3.179,5.144,5.144,0,0,1,7.069,7.069,5.142,5.142,0,0,0,3.176,7.671,5.141,5.141,0,0,1,0,9.991,5.142,5.142,0,0,0-3.179,7.674,5.144,5.144,0,0,1-7.069,7.069,5.142,5.142,0,0,0-7.671,3.176,5.141,5.141,0,0,1-9.991,0,5.142,5.142,0,0,0-7.674-3.179A5.144,5.144,0,0,1,10.1,42.509a5.142,5.142,0,0,0-3.176-7.671,5.141,5.141,0,0,1,0-9.991,5.142,5.142,0,0,0,3.179-7.674A5.144,5.144,0,0,1,17.176,10.1a5.137,5.137,0,0,0,7.671-3.176Z",
    transform: "translate(19588.818 6612.819)",
    fill: "#fff",
    stroke: "#a7a7a7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5651",
    "data-name": "Path 5651",
    d: "M9,17.948A8.948,8.948,0,1,0,17.948,9,8.948,8.948,0,0,0,9,17.948",
    transform: "translate(19600.715 6624.714)",
    fill: "none",
    stroke: "#a7a7a7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9475",
    "data-name": "Group 9475"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Polygon_6",
    "data-name": "Polygon 6",
    d: "M12.108,4.5a3,3,0,0,1,5.2,0l9.51,16.475a3,3,0,0,1-2.6,4.5H5.2a3,3,0,0,1-2.6-4.5Z",
    transform: "translate(780.598 358.235)",
    fill: "#ea3c3c"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "!",
    transform: "translate(793 377)",
    fill: "#fff",
    fontSize: 17,
    fontFamily: "AlBayan, Al Bayan"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "!")))), /*#__PURE__*/React.createElement("line", {
    id: "Line_659",
    "data-name": "Line 659",
    x2: 32,
    transform: "translate(714 359)",
    fill: "none",
    stroke: "#ededed",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_662",
    "data-name": "Line 662",
    x2: 12,
    transform: "translate(744 377)",
    fill: "none",
    stroke: "#ededed",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_663",
    "data-name": "Line 663",
    x2: 8,
    transform: "translate(750 338)",
    fill: "none",
    stroke: "#ededed",
    strokeLinecap: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_664",
    "data-name": "Line 664",
    x2: 8,
    transform: "translate(832 367)",
    fill: "none",
    stroke: "#ededed",
    strokeLinecap: "round",
    strokeWidth: 5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSymbol);
export default __webpack_public_path__ + "static/media/Error_symbol.a4f46550a80cd5ffa72264e8ea634a8e.svg";
export { ForwardRef as ReactComponent };